import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const LocalizedLink = ({ to, children, ...rest }) => {
  const { locale } = useIntl();

  if (to) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (<Link to={`/${locale}${to}`} {...rest}>{children}</Link>);
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return (<Link {...rest}>{children}</Link>);
};

LocalizedLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
};

export default LocalizedLink;
